
import { defineComponent } from 'vue';

export default defineComponent({
  name: "unidade-table",
  components: {

  },
  props: {
      rows: {
        type: Array,
        default: () => {
          [];
        },
      },
      getUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      deleteUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      searchCall: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
        sortKey: '', // Chave de ordenação
        sortAsc: true, // Direção da ordenação
        searchItem: false,
        searchIKey: '',
        searchQuery:''
      }
    },
    computed: {
      sortedData(){
        return this.rows.slice().sort((a:any, b:any) => {
          if (this.sortKey) {
            const keyA = a[this.sortKey];
            const keyB = b[this.sortKey];
            if (this.sortAsc) {
              return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
            } else {
              return keyA > keyB ? -1 : keyA < keyB ? 1 : 0;
            }
          }
          return 0;
        });
      },
    },
    methods: {
      // Método para alternar a ordenação
      searchData(key:any) {
        this.searchQuery=""
        if (this.searchIKey === key) {
          this.searchItem = !this.searchItem; // Alterna a direção da ordenação
        } else {
          this.searchIKey = key;
          this.searchItem = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },  
      sortData(key:any) {
        if (this.sortKey === key) {
          this.sortAsc = !this.sortAsc; // Alterna a direção da ordenação
        } else {
          this.sortKey = key;
          this.sortAsc = true; // Se mudar a chave, a ordenação será ascendente por padrão
        } 
      },   
      
      getColorClass(cor:string) {

        const cores = [
        { nome: "preta", hex: "#000000" },
        { nome: "branca", hex: "#fff" },
        { nome: "vermelha", hex: "#FF0000" },
        { nome: "verde", hex: "#00FF00" }, // Já neutra
        { nome: "azul", hex: "#0000FF" },  // Já neutra
        { nome: "amarela", hex: "#FFFF00" },
        { nome: "ciana", hex: "#00FFFF" },
        { nome: "magenta", hex: "#FF00FF" }, // Já neutra
        { nome: "cinza", hex: "#808080" },  // Já neutra
        { nome: "laranja", hex: "#FFA500" }, // Já neutra
        { nome: "roxa", hex: "#800080" },
        { nome: "marrom", hex: "#A52A2A" },  // Já neutra
        { nome: "rosa", hex: "#FFC0CB" },  // Já neutra
      ];;

      // return cores.find(c => c.nome.toLowerCase() === cor.toLowerCase())?.hex || "text-secondary";
        const cor_r = cores.find(c => c.nome.toLowerCase() === cor.toLowerCase());
        return {  color: cor_r?.nome === "branca" ? "#000000" :"#fff",
                  backgroundColor: cor_r?.hex || "#888888",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  border: "1px solid",
                  borderColor: cor_r?.nome === "branca" ? "#000000" : cor_r?.hex || "#888888"
                }; 

      }

    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const getUnico = (row: any) => {
          props.getUnico(row); // Define o novo cen tro do mapa
      };

      const salvarUnico = (data:any) => {
          props.salvarUnico(data); // Define o novo cen tro do mapa
      };

      const deleteUnico = (row: any) => {
          props.deleteUnico(row); // Define o novo cen tro do mapa
      };

      const searchCall = (field:any, termo:any) => {
        props.searchCall(field, termo); // Define o novo cen tro do mapa
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        getUnico,
        salvarUnico,
        deleteUnico,
        searchCall,
      };

    }

});
